export const USER_ERRORS = {
	NOT_FOUND: "user_not_found",
} as const;

export type UserErrorCode = (typeof USER_ERRORS)[keyof typeof USER_ERRORS];
